module.exports = "/src/views/player/help/images/tatoo2.jpg";